export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/LinActSaleIns',
		name: 'NbuLinActSaleIns',
		title: {
			single: 'NbuLinActSaleIns',
			plural: 'NbuLinActSaleIns'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "2005",
				"code": "R",
				"name": "отримання перестрахової виплати від перестраховика та подальше її перерахування перестрахувальнику",
				"caption": "отримання перестрахової виплати від перестраховика та подальше її перерахування перестрахувальнику",
				"isBlocked": false
			},
			{
				"id": "2003",
				"code": "R",
				"name": "отримання перестрахової премії від перестрахувальника та подальше її перерахування перестраховику",
				"caption": "отримання перестрахової премії від перестрахувальника та подальше її перерахування перестраховику",
				"isBlocked": false
			},
			{
				"id": "1005",
				"code": "I",
				"name": "отримання страхової виплати від страховика та подальше її перерахування клієнту",
				"caption": "отримання страхової виплати від страховика та подальше її перерахування клієнту",
				"isBlocked": false
			},
			{
				"id": "1003",
				"code": "I",
				"name": "отримання страхової премії від клієнта та подальше її перерахування страховику",
				"caption": "отримання страхової премії від клієнта та подальше її перерахування страховику",
				"isBlocked": false
			},
			{
				"id": "2004",
				"code": "R",
				"name": "оформлення необхідних документів для своєчасного здійснення перестрахової виплати перестраховиком",
				"caption": "оформлення необхідних документів для своєчасного здійснення перестрахової виплати перестраховиком",
				"isBlocked": false
			},
			{
				"id": "1004",
				"code": "I",
				"name": "оформлення необхідних документів для своєчасного здійснення страхової виплати та інша діяльність, пов’язана з організацією врегулювання страхового випадку",
				"caption": "оформлення необхідних документів для своєчасного здійснення страхової виплати та інша діяльність, пов’язана з організацією врегулювання страхового випадку",
				"isBlocked": false
			},
			{
				"id": "2001",
				"code": "R",
				"name": "пропозиція та консультування перестрахувальника щодо укладення договору перестрахування",
				"caption": "пропозиція та консультування перестрахувальника щодо укладення договору перестрахування",
				"isBlocked": false
			},
			{
				"id": "1001",
				"code": "I",
				"name": "пропонування, пропозиція та консультування клієнта щодо укладення договору страхування, проведення іншої роботи з підготовки до укладення договорів страхування",
				"caption": "пропонування, пропозиція та консультування клієнта щодо укладення договору страхування, проведення іншої роботи з підготовки до укладення договорів страхування",
				"isBlocked": false
			},
			{
				"id": "2000",
				"code": "R",
				"name": "рекламування та/або проведення маркетингових, рекламних та інших підготовчих заходів, спрямованих на укладення договорів перестрахування, зокрема, але не виключно, надання інформації про умови договору перестрахування відповідно до критеріїв та/або потреб, визначених перестрахувальниками",
				"caption": "рекламування та/або проведення маркетингових, рекламних та інших підготовчих заходів, спрямованих на укладення договорів перестрахування, зокрема, але не виключно, надання інформації про умови договору перестрахування відповідно до критеріїв та/або потреб, визначених перестрахувальниками",
				"isBlocked": false
			},
			{
				"id": "1000",
				"code": "I",
				"name": "рекламування та/або проведення маркетингових, рекламних та інших підготовчих заходів, спрямованих на укладення договорів страхування, зокрема, але не виключно, надання інформації про умови договору страхування відповідно до критеріїв та/або потреб, визначених клієнтами, проведення порівняльного аналізу за критеріями клієнтів, консультування щодо умов договору страхування відповідно до критеріїв та/або потреб, визначених клієнтами",
				"caption": "рекламування та/або проведення маркетингових, рекламних та інших підготовчих заходів, спрямованих на укладення договорів страхування, зокрема, але не виключно, надання інформації про умови договору страхування відповідно до критеріїв та/або потреб, визначених клієнтами, проведення порівняльного аналізу за критеріями клієнтів, консультування щодо умов договору страхування відповідно до критеріїв та/або потреб, визначених клієнтами",
				"isBlocked": false
			},
			{
				"id": "2002",
				"code": "R",
				"name": "укладення та внесення змін до договору перестрахування (ковер-ноти, сертифіката, поліса, свідоцтва тощо), зокрема, але не виключно, залучення до оцінювання страхового ризику, вірогідності настання страхової події, оформлення документів та розрахунків за договором перестрахування",
				"caption": "укладення та внесення змін до договору перестрахування (ковер-ноти, сертифіката, поліса, свідоцтва тощо), зокрема, але не виключно, залучення до оцінювання страхового ризику, вірогідності настання страхової події, оформлення документів та розрахунків за договором перестрахування",
				"isBlocked": false
			},
			{
				"id": "1002",
				"code": "I",
				"name": "укладення та внесення змін до договору страхування, зокрема, але не виключно, залучення до оцінювання страхового ризику, вірогідності настання страхової події, оформлення документів та розрахунків щодо сплати страхової премії",
				"caption": "укладення та внесення змін до договору страхування, зокрема, але не виключно, залучення до оцінювання страхового ризику, вірогідності настання страхової події, оформлення документів та розрахунків щодо сплати страхової премії",
				"isBlocked": false
			}
		],
	},
}
